import {
  ADD_BOOK_ID,
  ADD_CONTEXT,
  ADD_FOLDER_ID,
  SAVE_BOOK_SIZES,
  LOAD_BOOK_SIZES_BY_BOOK_ID,
  LOAD_BOOK_COVER_BY_BOOK_ID,
  GET_BOOK_COVER,
  GET_BOOK_DIMENSIONS,
  GET_COVER_MARGINS,
  GET_COVER_SIZES,
  UPDATE_COVER_SIZE,
  ADD_AUTOFILL,
  MAX_SHEETS,
  UPDATE_COVER_MARGIN_SIZE,
  UPDATE_BOOK_RATIO,
  LOAD_BOOK_CONTEXT,
  ADD_PLACEHOLDER_BORDER_SIZE,
  LOAD_PLACEHOLDER_BORDER_SIZE,
  SET_IS_BABY_BOOK,
  LOAD_BABY_BOOK_STATUS,
  UPDATE_BOOK_SIZES,
  LOAD_BOOK_DIMENSIONS,
} from './../../action-types/bookproperties';

export const addBookId = bookId => ({
  type: ADD_BOOK_ID,
  bookId,
});

export const addPlaceholderBorderSize = borderSize => ({
  type: ADD_PLACEHOLDER_BORDER_SIZE,
  borderSize,
});

export const addContext = context => ({
  type: ADD_CONTEXT,
  context,
});

export const addFolderId = folderId => ({
  type: ADD_FOLDER_ID,
  folderId,
});

export const addAutoFill = status => ({
  type: ADD_AUTOFILL,
  status,
});

export const maxSheets = pages => ({
  type: MAX_SHEETS,
  pages,
});

export const saveBookSizes = (width, height, margin, ratio) => ({
  type: SAVE_BOOK_SIZES,
  width,
  height,
  margin,
  ratio,
});

export const loadBookSizesByBookId = bookState => ({
  type: LOAD_BOOK_SIZES_BY_BOOK_ID,
  bookState,
});

export const loadBookCoverByBookId = bookState => ({
  type: LOAD_BOOK_COVER_BY_BOOK_ID,
  bookState,
});

export const getBookCover = (cover, margins) => ({
  type: GET_BOOK_COVER,
  cover,
  margins,
});

export const getBookDimensions = dimensions => ({
  type: GET_BOOK_DIMENSIONS,
  dimensions,
});

export const getCoverMargins = margins => ({
  type: GET_COVER_MARGINS,
  margins,
});

export const getCoverSizes = (width, height, widthInPx, heightInPx) => ({
  type: GET_COVER_SIZES,
  width,
  height,
  widthInPx,
  heightInPx,
});

export const updateCoverSizes = (width, height, widthInPx, heightInPx) => ({
  type: UPDATE_COVER_SIZE,
  width,
  height,
  widthInPx,
  heightInPx,
});

export const updateCoverMarginSize = marginSize => ({
  type: UPDATE_COVER_MARGIN_SIZE,
  marginSize,
});

export const updateBookRatio = ratio => ({
  type: UPDATE_BOOK_RATIO,
  ratio,
});

export const loadBookContext = context => ({
  type: LOAD_BOOK_CONTEXT,
  context,
});

export const loadBookDimensions = state => ({
  type: LOAD_BOOK_DIMENSIONS,
  state,
});

export const loadPlaceholderBorderSize = size => ({
  type: LOAD_PLACEHOLDER_BORDER_SIZE,
  size,
});

export const loadBabyBookStatus = status => ({
  type: LOAD_BABY_BOOK_STATUS,
  status,
});

export const setIsBabyBook = status => ({
  type: SET_IS_BABY_BOOK,
  status,
});

export const updateBookSizes = sizes => ({
  type: UPDATE_BOOK_SIZES,
  sizes,
});




// WEBPACK FOOTER //
// ./src/redux/actions/bookproperties/index.js